/** @jsx jsx */
import React from 'react';
import { jsx, SxStyleProp } from 'theme-ui';

import SVGJLetter from './symbols/SVGJLetter';
import SVGALetter from './symbols/SVGALetter';
import SVGZLetter from './symbols/SVGZLetter';
import SVGBZLetter from './symbols/SVGBZLetter';

const defaultProps: SxStyleProp = {
  position: 'absolute',
};

const JAZZLetters: React.FC = ({}) => {
  return (
    <div
      sx={{
        position: 'relative',
        height: '100%',
        width: '100%',
      }}
    >
      <SVGJLetter
        sx={{ ...defaultProps, top: '3vh', left: '1%', width: '15%' }}
      />
      <SVGALetter
        sx={{ ...defaultProps, top: '15vh', right: '9%', width: '7%' }}
      />
      <SVGZLetter
        sx={{
          ...defaultProps,
          left: '4%',
          bottom: '-62vh',
          width: '13%',
        }}
      />
      <SVGBZLetter
        sx={{
          ...defaultProps,
          bottom: '-80vh',
          right: '3%',
          width: '15%',
        }}
      />
    </div>
  );
};

export default JAZZLetters;
